"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a th element and applieds sortReverse, enabled sort styles and handlers to them automatically
 */
var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./SortableTableHeadItem.less");

var SortableTableHeadItem = function (_Component) {
    _inherits(SortableTableHeadItem, _Component);

    function SortableTableHeadItem() {
        var _Object$getPrototypeO;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        _classCallCheck(this, SortableTableHeadItem);

        var _this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SortableTableHeadItem)).call.apply(_Object$getPrototypeO, [this].concat(args)));

        _this.handleClick = function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            if (_this.props.handleClick) {
                _this.props.handleClick(args);
            }
        };
        return _this;
    }

    _createClass(SortableTableHeadItem, [{
        key: "render",
        value: function render() {
            var baseClass = "item";
            var icon = null;
            if (this.props.selected) {
                baseClass = "item-selected";
                icon = React.createElement("i", { styleName: "icon", className: "fa fa-sort-desc" });
                if (this.props.reversed) {
                    baseClass = "item-reversed";
                    icon = React.createElement("i", { styleName: "icon", className: "fa fa-sort-asc" });
                }
            }
            var filterIcon = React.createElement("i", { styleName: "icon", className: " fa fa-filter" });
            return React.createElement("th", __assign({ role: "button", styleName: baseClass, onTouchTap: this.handleClick }, this.props), this.props.label, " ", icon, " ", this.props.filterIcon ? filterIcon : "");
        }
    }]);

    return SortableTableHeadItem;
}(_react.Component);
SortableTableHeadItem.propTypes = {
    handleClick: _react.PropTypes.func,
    label: _react.PropTypes.oneOfType([_react.PropTypes.string.isRequired, _react.PropTypes.element.isRequired]),
    selected: _react.PropTypes.bool.isRequired,
    reversed: _react.PropTypes.bool.isRequired,
    filterIcon: _react.PropTypes.bool
};
SortableTableHeadItem = __decorate([(0, _reactCssModules2.default)(styles)], SortableTableHeadItem);
exports.default = SortableTableHeadItem;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SortableTableHeadItem.tsx
 ** module id = 1304
 ** module chunks = 0
 **/